import { cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';

import { formatAmount } from '../lib/helpers.tsx';
import { ITransaction } from '../model/types.ts';
import { VabsPaymentSystem } from '@/shared/api/index.ts';

interface TopUpAmountProps {
  transaction: ITransaction;
  className?: string;
}

export const TopUpAmount = ({ transaction, className }: TopUpAmountProps) => {
  const isExchange = transaction.paymentSystem === VabsPaymentSystem.Exchange
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <Typography variant="16-r" className="whitespace-nowrap text-right">
        {formatAmount(+transaction.sourceAmount, transaction.sourceCurrency, 2, '+')}
      </Typography>
      {isExchange && transaction.sourceAmount && (
        <Typography
          variant="14-r"
          color="text-base-100"
          className="whitespace-nowrap text-right"
        >
          {formatAmount(
            transaction.sourceAmount,
            transaction.sourceCurrency,
            2,
            '-'
          )}
        </Typography>
      )}
    </div>
  );
};
